import * as React from "react";
import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  // Route,
  // ‚Link,
  Outlet,
  // createRoutesFromElements,
} from "react-router-dom";
// import About from "./routes/About";
import EVTools from "./routes/EVTools";
import Timer from "./routes/Timer";
import RemoteTimer from "./routes/RemoteTimer.jsx";
import FastVote from "./routes/FastVote.jsx";
import QRCodeGenerator from "./routes/QRCodeGenerator.jsx";
import Development from "./routes/Development.jsx";
import PerformFitness from "./routes/PerformFitness.jsx";
import CamperMonitor from "./routes/CamperMonitor.jsx";
import CamperSolarMonitorApp from "./routes/CamperSolarMonitorApp.jsx";
import PrivacyCamperSolarMonitor from "./routes/PrivacyCamperSolarMonitor.jsx";
import PrivacyPerformFitness from "./routes/PrivacyPerformFitness.jsx";
import BTScanner from "./routes/BTScanner.jsx";
import PrivacyBTScanner from "./routes/PrivacyBTScanner.jsx";
import DCLadekarten from "./routes/DCLadekarten.jsx";
import Licenses from "./routes/Licenses.jsx";
import Home from "./routes/Home";
import Imprint from "./routes/Imprint";
import RepaymentPlan from "./routes/RepaymentPlan";
import CamperTools from "./routes/CamperTools.jsx";
import Template from "./routes/Template.js";
import Navbar from "./components/Navbar";
import { LanguageProvider } from "./LanguageContext";
import "./App.css";

const AppLayout = () => (
  <>
    <Navbar />
    <Outlet />
  </>
);

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "evtools",
        element: <EVTools />,
      },
      {
        path: "timer",
        element: <Timer />,
      },
      {
        path: "remote-timer",
        element: <RemoteTimer />,
      },
      {
        path: "fastvote",
        element: <FastVote />,
      },
      {
        path: "qrcode",
        element: <QRCodeGenerator />,
      },
      /* {
        path: "about",
        element: <About />,
      }, */
      {
        path: "imprint",
        element: <Imprint />,
      },
      {
        path: "repayment",
        element: <RepaymentPlan />,
      },
      {
        path: "cablecalc",
        element: <CamperTools />,
      },
      {
        path: "development",
        element: <Development />,
      },
      {
        path: "perform-fitness",
        element: <PerformFitness />,
      },
      {
        path: "perform-fitness/privacy",
        element: <PrivacyPerformFitness />,
      },
      {
        path: "btble-scanner",
        element: <BTScanner />,
      },
      {
        path: "btble-scanner/privacy",
        element: <PrivacyBTScanner />,
      },
      {
        path: "camper-monitor",
        element: <CamperMonitor />,
      },
      {
        path: "camper-solar-monitor-app",
        element: <CamperSolarMonitorApp />,
      },
      {
        path: "camper-solar-monitor-app/privacy",
        element: <PrivacyCamperSolarMonitor />,
      },
      {
        path: "licenses",
        element: <Licenses />,
      },
      {
        path: "template",
        element: <Template />,
      },
    ],
  },
  {
    path: "dc",
    element: <DCLadekarten />,
  },
]);

createRoot(document.getElementById("root")).render(
  <LanguageProvider>
    <RouterProvider router={router} />
  </LanguageProvider>
);
